import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractVisbosComponent} from '../../../core/visbos-core/components/abstract-visbos.component';
import {SessionActions} from '../../../shared/actions';
import {RfidService} from '../../services/rfid.service';
import {RetrieveEPCsByReaderQuery} from '../../../shared/graphql/graphql.types';
import {Observable} from 'rxjs';
import {ApolloQueryResult} from 'apollo-client';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'vb-rfid-reader',
  templateUrl: './rfid-reader.component.html',
  styleUrls: ['./rfid-reader.component.css']
})
export class RfidReaderComponent extends AbstractVisbosComponent implements OnInit, OnDestroy {

  @Input()
  title = 'Lesevorgang starten';

  @Input()
  readerId: string;

  @Input()
  style: 'icon' | 'button' | 'block' = 'button';

  @Input()
  onlyOnce = true;

  @Output()
  read: EventEmitter<string[]> = new EventEmitter();

  private readerQuery$: Observable<ApolloQueryResult<RetrieveEPCsByReaderQuery>>;
  public epcs: string[];


  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private rfidService: RfidService) {
    super(sessionActions, cd);
  }

  onReadClicked() {
    if (this.onlyOnce && this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.readerQuery$ = this.rfidService
      .retrieveEPCsFromReaderOnce({readerCuid: this.rfidService.getReaderForMarriage()})
      .pipe(finalize(() => {
        this.isLoading = false;
      }));

    this.addSubscription(this.readerQuery$.subscribe(res => {
      this.isLoading = res.loading;
      this.handleReadResult(res.data.epcsByReader);
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Lesen der RFID-Tags!");
      this.isLoading = false;
    }));
  }

  private handleReadResult(epcs: string[]) {
    this.epcs = epcs;
    this.read.emit(epcs);
  }


  ngOnDestroy() {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// ./src/app/identity/rfid/rfid-reader/rfid-reader.component.ts